import GameConfig from "../config";
import {Vector3, Raycaster, ArrowHelper, LoopOnce, LoopRepeat} from "three";
import SoundManager from "../sound/SoundManager";
import * as THREE from "three";
import config from "../config";
import ThreeFX from "../fx/threeFX";

const RAYCASTER_DIRECTIONS = {
    FORWARD: "FORWARD",
    BOTTOM: "BOTTOM"
}

const ANIMATION_KEYS = {
    RUN: "Run",
    FALL: "Fall",
    IDLE: "Idle",
    JUMP: "Jump",
    ATTACK: "Attack",
    TOUCH_GROUND: "TOUCH_GROUND"
}

const ANIMATIONS = {
    "ATTACK": 0,
    "FALL": 1,
    "IDLE": 2,
    "JUMP": 3,
    "RUN": 4,
    "TOUCH_GROUND": 5
}

export default class GameObject {
    constructor({mesh, game, parent, scale = 1}) {
        this.parent = parent;
        this.game = game;
        this.mesh = mesh;
        this.mesh.scale.set(scale, scale, scale);
        this.parent.add(this.mesh);
        this.animationClips =
            this.mesh.mixer._actions.map(a => a._clip);
        this.update();
        if(GameConfig.DEBUG.ON && GameConfig.DEBUG.HIDE_PLAYER){
            this.mesh.visible = false;
        }
        this.speed = GameConfig.GENERAL.START_SPEED;
        this.switchAnimation(ANIMATION_KEYS.RUN);
        this.createBoundingBox();
        this.line = 0;
        this.life = 3;
        this.sheltherTime = 0;
        this.time = 0;
        this.score = 0;
        this.trail = ThreeFX.emitTail(0,0, '#4F4500','#4F1500');
    }

    colorRed(){
        this.mesh.traverse(o => {
            if(o.material){
                o.material.color.setHex(0xff0000)
            }
        });
        this.coloredNormal = false;
    }

    colorNormal(){
        if(this.coloredNormal) return;
        this.mesh.traverse(o => {
            if(o.material){
                o.material.color.setHex(0xffffff)
            }
        });
        this.coloredNormal = true;
    }

    handleCollision(){
        if(this.sheltherTime <= 0){
            this.life--;
            this.sheltherTime = 3;
            if(this.life > 0) this.colorRed();
            this.game.game.UI.sequence.destroy();
            return true;
        }
        return false;
    }

    createBoundingBox(){
        const dim = config.GENERAL.PLAYER_BOUNDING_BOX_SCALE;
        const geometry = new THREE.BoxGeometry( dim, dim, dim);

        const material = new THREE.MeshStandardMaterial( {color: 0xff0000} );
        this.boundingBox = new THREE.Mesh( geometry, material );
        this.boundingBox.geometry.computeBoundingBox();

        this.boundingBox.visible = false;

        if(GameConfig.DEBUG.ON && GameConfig.DEBUG.PHYSICS){
            this.boundingBox.visible = true;
        }

        this.parent.add(this.boundingBox);
    }

    getAnimationClip(name){
        return this.animationClips.find(ac => ac.name === name);
    }


    turnLeft(){
        if(this.isJumping) return;
        if(this.line > -1 && !this.lineSwitching){
            this.line--;
            this.lineSwitching = true;
            this.game.tweens.add({
                targets: [this.mesh.position],
                x: -2 * this.line,
                duration: 300,
                ease: Phaser.Math.Easing.Linear
            }).on("complete", () => {
                this.lineSwitching = false;
            })
        }
    }
    turnRight(){
        if(this.isJumping) return;
        if(this.line < 1 && !this.lineSwitching){
            this.line++;
            this.lineSwitching = true;
            this.game.tweens.add({
                targets: [this.mesh.position],
                x: -2 * this.line,
                duration: 300,
                ease: Phaser.Math.Easing.Linear
            }).on("complete", () => {
                this.lineSwitching = false;
            })
        }
    }

    jump(){
        if(this.isJumping || this.dead || this.lineSwitching) return;
        this.isJumping = true;

        this.game.tweens.add({
            targets: [this.mesh.position],
            y: 3,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 400,
            delay: 0,
            yoyo: true
        }).on("complete", () => {
            this.isJumping = false;
            this.switchAnimation(ANIMATION_KEYS.RUN);
        })

        const clipAction = this.switchAnimation(ANIMATION_KEYS.JUMP);
        clipAction.clampWhenFinished = true;
        clipAction.setLoop(LoopOnce);
        /*const that = this;
        this.mesh.mixer.addEventListener( 'finished', function evtL( e ) {
            console.log("fall");
            that.jumping = false;
            that.mesh.mixer.removeEventListener('finished', evtL);
            const clipAction = that.switchAnimation(ANIMATION_KEYS.FALL);
            clipAction.setLoop(LoopRepeat);
        });
        */
        SoundManager.playFX("jump");
    }

    sign(number){
        if(number === 0) return 1;
        return Math.abs(number) / number;
    }

    attack(){
        const animationAction = this.mesh.mixer.clipAction(this.getAnimationClip(ANIMATION_KEYS.ATTACK))
            .reset()
            .setEffectiveWeight(2)
            .setEffectiveTimeScale(2)
            .fadeIn(0.1)
            .setLoop(THREE.LoopPingPong)
            .play();
        animationAction.repetitions = 0;
        animationAction.blendMode = THREE.AdditiveBlending;
    }

    switchAnimation(key){
        if(!this.activeAction) {
            this.activeAction = key;
            return this.mesh.mixer
                .clipAction(this.getAnimationClip(key))
                .play();
        }

        if(key === this.activeAction)
            return this.mesh.mixer
                .clipAction(this.getAnimationClip(this.activeAction));

        //this.mesh.mixer.stopAllAction();

        this.mesh.mixer.clipAction(this.getAnimationClip(this.activeAction)).fadeOut(0.2)
        const animationAction =this.mesh.mixer.clipAction(this.getAnimationClip(key))
            .reset()
            .setEffectiveWeight(1)
            .setEffectiveTimeScale(1)
            .fadeIn(0.2)
            .play();

        this.activeAction = key;
        return animationAction;
    }

    die(){
        return new Promise((resolve) => {

            const dieTime = 200;

            this.dead = true;
            this.game.tweens.add({
                targets: [this.mesh.rotation],
                x: Math.PI /2,
                duration: dieTime
            }).on("complete", () => {
                this.mesh.mixer.stopAllAction();
                this.trail.destroy();
                resolve();
            })

            this.game.tweens.add({
                targets: [this],
                speed: 0,
                duration: dieTime
            })

            this.game.tweens.add({
                targets: [this.mesh.position],
                y: 0,
                duration: this.mesh.position.y * dieTime
            })

            this.mesh.mixer
                .clipAction(this.getAnimationClip(this.activeAction))
                .fadeOut(dieTime / 1000)
        })
    }

    update(deltaS){
        if(deltaS) {
            //this.mesh.position.z += this.speed * deltaS;
            this.boundingBox.position.copy(this.mesh.position);
            this.sheltherTime -= deltaS;
            if(this.sheltherTime <= 0) this.colorNormal();
            this.trail.p.x = this.mesh.position.x;
            this.trail.p.y = this.mesh.position.y + 0.125;
            if(this.mesh.mixer) this.mesh.mixer.update(deltaS);
        }
    }
}